import React from "react";
import Card from "../Card";
import PropertyCarousel from "../PropertyCarousel";
import Blog from "../BlogList";
import Landing from "./Landing";
import { Wrap } from "./style";
import { NavLink } from "react-router-dom";
import Discover from "./Discover";
const HomeComponent = () => {
  return (
    <Wrap>
      <Landing />
      <Discover />
      <Card />
      <PropertyCarousel />
      <Blog />
      <Wrap.Register>
        <Wrap.Title>Become a Real Estate Agent</Wrap.Title>
        <Wrap.Des>
          We only work with the best companies around the globe
        </Wrap.Des>
        <Wrap.Button>
          <NavLink to="/register-as-realtor">REGISTER NOW</NavLink>
        </Wrap.Button>
      </Wrap.Register>
    </Wrap>
  );
};

export default HomeComponent;
